import {parseISO} from "date-fns";
import _ from "lodash";
import {diffTime} from "../../../Sales/helpers/func_helpers";
import {isFreeEventDateAPI} from "../../../../../../../services/api/calculator";

const compositionDefault = [{ value: "Tutti", label: "Tutti", color: "#00ace6"},]

const compositionOptionsInit = [
    {value: "Tutti", label: "effectif.composition*", color: '#00ace6'},
    // {value: 'Tutti', label: 'Tutti', color: '#00ace6', isDisabled: true}
];

const timeStartEnd = type => {
    switch (type) {
        case "rehearsals":
            return ["19:30", "22:00"];
        case "raccords":
            return ["17:00", "17:45"];
        case "concerts":
            return ["20:00", "22:00"];
    }
};

const isFreeEventDate = async (eventDate) => {
    const response = await isFreeEventDateAPI(eventDate)
    return response.data
}

const eventDetailUnit = (key, type, kzmProject) => ({
    key: key,
    eventDate: new Date(),
    startTime: timeStartEnd(type)[0],
    endTime: timeStartEnd(type)[1],
    eventLength: diffTime(timeStartEnd(type)[0], timeStartEnd(type)[1]),
    type: type,
    composition: compositionDefault,
    musReduction: 0,
    isConductor: true,
    kzmEvent: kzmProject,
    location: "",
    room: "",
});

const INITIAL_STATE = {
    events: {rehearsals: 0, raccords: 0, concerts: 0,},
    eventsDetails: [],
    details: false,
    compositionOptions: compositionOptionsInit,
    roomsList: [],
    locations: [],
    popup: {show: false, title: '', variant: 'error', message: ''},
}


const eventsReducer = (state, action) => {
    switch (action.type) {
        case "INITIAL_DATA":
            const locations = action.locations.map(el => {
                return {
                    pk: el.pk,
                    value: el.name,
                    label: el.name,
                    rooms: el.rooms,
                };
            });
            locations.unshift({
                pk: "",
                value: "to_define",
                label: action.t("location.to_define"),
                rooms: [],
            });
            const eventsDetails = action.eventsDetails.map(el => {
                return {...el, eventDate: new parseISO(el.eventDate)};
            })
            return {
                ...state,
                eventsDetails: eventsDetails,
                events: action.events,
                details: action.details,
                kzmProject: action.kzmProject,
                staff: action.staff,
                conductor: action.conductor,
                roomsList: action.roomsList,
                locations: locations,
            }
            break
        case "SET_EVENTS":
        case "SET_EVENTS_DETAILS":
        case "SET_ROOM_LIST":
        case "SET_DETAILS":
        case "SET_POPUP":
            return {...state, [action['key']]: action.dataset};
            break
        case "SET_COMPOSITION_OPTIONS":
            return {...state, compositionOptions: action.compositionOptions};
            break
        case "SET_COMPOSITION_MARKED_INSTR":
            const evDetailCopy = structuredClone(state.eventsDetails);
            const evSelected = evDetailCopy.find(({key}) => key === action.data.key)
            if (evSelected) {
                evSelected.composition = action.data.composition;
            }
            return {...state, eventsDetails: evDetailCopy};
        case "SET_LOCATIONS":
            return {...state, locations: action.locations};
            break
        case "REMOVE_EVENT_DETAIL":
            const eventsDetailsCopy = structuredClone(state.eventsDetails);
            const indexDel = eventsDetailsCopy.findIndex(
                el => el.key === action.eventDetailKey
            );
            eventsDetailsCopy.splice(indexDel, 1);
            const newEvents = _.cloneDeep(state.events);
            newEvents[action.evType] -= 1;

            return {...state, events: newEvents, eventsDetails: eventsDetailsCopy};
            break
        case "CHANGE_DETAILS_TYPE":
            // zmienia typ eventu np rehearsals/raccords/concerts
            const eventDetCopy = structuredClone(state.eventsDetails)
            const elementChange = eventDetCopy.find(
                el => el.key === action.eventDetailKey
            )
            // events couters modify
            const type_old = elementChange.type
            const eventsCopy = structuredClone(state.events)
            const old_value = +eventsCopy[type_old] -1
            const new_value = +eventsCopy[action.val] +1
            eventsCopy[type_old] = old_value
            eventsCopy[action.val] = new_value
            elementChange.type = action.val
            elementChange['startTime'] = timeStartEnd(action.val)[0]
            elementChange['endTime'] = timeStartEnd(action.val)[1]

            const indexEventDet = eventDetCopy.findIndex(
                el => el.key === action.eventDetailKey
            )
            eventDetCopy.splice(indexEventDet, 1, elementChange)
            return {...state, events: eventsCopy, eventsDetails: eventDetCopy};
            break
        default:
            throw new Error('Unknown action: ' + action);
    }
}

export {
    eventsReducer,
    INITIAL_STATE,
    compositionDefault,
    eventDetailUnit,
}